import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { isStaff } from '../../domain/roles.ts';
import { Button } from '../../ui/Button.tsx';
import { useAuth } from './auth-context.ts';

// Las guardas de ruta son apoyo visual; la autorización real está en RLS y RPCs.
export function RequireAuth({ children }: { children: ReactNode }) {
  const { state, refreshProfile, signOut } = useAuth();
  const location = useLocation();

  if (state.status === 'loading') {
    return (
      <div className="fullscreen-status" aria-busy="true">
        Cargando…
      </div>
    );
  }
  if (state.status === 'signedOut') return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (state.status === 'error') {
    return (
      <div className="fullscreen-status">
        <p>{state.error.message}</p>
        <div className="row">
          <Button onClick={() => void refreshProfile()}>Reintentar</Button>
          <Button variant="ghost" onClick={() => void signOut()}>
            Cerrar sesión
          </Button>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}

export function RequireStaff({ children }: { children: ReactNode }) {
  const { state } = useAuth();
  if (state.status !== 'ready' || !isStaff(state.profile.role)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
